<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="epg-image-slider" fxLayout="row" [class.stretch]="stretchToContainer">
  <div
    [ngClass]="{ 'slider-border': displayBorder, stretch: stretchToContainer }"
    fxLayout="row"
  >
    <div
      class="slider-image-container"
      [class.stretch]="stretchToContainer"
      *ngFor="let image of images; let i = index; trackBy: trackByImage"
    >
      <div
        fxLayoutAlign="center center"
        class="image-wrapper spacing-xs"
        [class.stretch]="stretchToContainer"
        [ngStyle]="{
        height: imageHeightInPx + 'px',
      }"
      >
        <div
          *ngIf="image.imageLoadingStatus == ImageLoadingStatus.LOADING"
          fxFill
          fxLayoutAlign="center center"
        >
          <fa-icon
            class="icon loading_spinner"
            [icon]="faSpinnerThird"
            aria-label="loading spinner"
          ></fa-icon>
        </div>
        <img
          #imageElement
          *ngIf="image.imageLoadingStatus == ImageLoadingStatus.LOADED"
          [src]="image.image"
          class="slider-image"
          [class.stretch]="stretchToContainer"
          (click)="openModal(i)"
          (load)="onImageLoad(i)"
        />
        <div
          *ngIf="image.imageLoadingStatus == ImageLoadingStatus.ERROR"
          id="image-not-found-area"
          fxLayoutAlign="center center"
          fxLayout="column"
        >
          <fa-icon [icon]="faImage"></fa-icon>
          <span class="area-text" i18n="could not load image!@@couldNotLoadImageErrorMessage"
            >could not load image!</span
          >
        </div>
      </div>
      <div #captionContainer class="image-list-caption spacing-xs" [matTooltip]="image.title ?? ''">
        {{ image.title }}
      </div>
    </div>
  </div>
</div>

<div id="lightbox" class="epg-slider-lightbox" #lightbox>
  <div class="lightbox-content">
    <ng-container *ngFor="let image of images; let i = index">
      <div
        class="lightbox-slide"
        [ngStyle]="i === slideIndex ? { display: 'flex' } : { display: 'none' }"
      >
        <span class="close cursor" (click)="closeModal()">
          <span i18n="label for Close (Esc)@@close(Esc)">Close (Esc)</span>&nbsp;
          <fa-icon [icon]="faXmark"></fa-icon>
        </span>
        <div class="image-cover">
          <div
            *ngIf="image.imageLoadingStatus == ImageLoadingStatus.LOADING"
            fxFill
            fxLayoutAlign="center center"
          >
            <fa-icon
              class="icon loading_spinner"
              [icon]="faSpinnerThird"
              aria-label="loading spinner"
            ></fa-icon>
          </div>
          <img
            *ngIf="image.imageLoadingStatus == ImageLoadingStatus.LOADED"
            [ngStyle]="{
              transform:
                'translate(0px, 0px) scale(' +
                image.scaleValue +
                ')' +
                'rotate(' +
                image.rotationValue +
                'deg)',
              top: image.zoomTopMargin + '%'
            }"
            [src]="image.image"
            class="lightbox-image"
            [ngClass]="
              image.rotationValue == 0 || image.rotationValue == -180
                ? 'original-view'
                : 'landscape-view'
            "
          />
          <div *ngIf="images.length > 1" class="numbertext">
            {{ slideIndex + 1 }}/{{ images.length }}
          </div>
        </div>
      </div>
      <div
        class="lightbox-controls"
        [ngStyle]="i === slideIndex ? { display: 'flex' } : { display: 'none' }"
      >
        <div class="lightbox-caption" id="caption" [matTooltip]="image.title ?? ''">
          {{ image.title }}
        </div>
        <div class="image-button-row">
          <button
            mat-mini-fab
            (click)="imageZoomIn(image)"
            matTooltip="Zoom in"
            i18n-matTooltip="@@zoomIn"
          >
            <fa-icon [icon]="faMagnifyingGlassPlus"></fa-icon>
          </button>
          <button
            mat-mini-fab
            (click)="imageZoomOut(image)"
            matTooltip="Zoom out"
            i18n-matTooltip="@@zoomOut"
          >
            <fa-icon [icon]="faMagnifyingGlassMinus"></fa-icon>
          </button>
          <button
            mat-mini-fab
            (click)="rotateImage(image)"
            matTooltip="Rotate"
            i18n-matTooltip="@@rotate"
          >
            <fa-icon [icon]="faUndo"></fa-icon>
          </button>
          <button
            mat-mini-fab
            (click)="downloadImage(image)"
            matTooltip="Download"
            i18n-matTooltip="@@download"
          >
            <fa-icon [icon]="faDownload"></fa-icon>
          </button>
        </div>
      </div>
    </ng-container>
    <!-- Next/previous controls -->
    <button
      *ngIf="this.images.length > 1"
      mat-mini-fab
      class="prev"
      (click)="rotateSlides(-1)"
      matTooltip="Previous"
      i18n-matTooltip="@@previous"
    >
      <fa-icon [icon]="faArrowLeft"></fa-icon>
    </button>
    <button
      *ngIf="this.images.length > 1"
      mat-mini-fab
      class="next"
      (click)="rotateSlides(1)"
      matTooltip="Next"
      i18n-matTooltip="@@next"
    >
      <fa-icon [icon]="faArrowRight"></fa-icon>
    </button>
  </div>
</div>
